import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ConfigService } from 'src/app/services/config.service';
import { ApiService } from 'src/app/services/communications/api.service';
import { UserDataService } from 'src/app/services/userData.service';
import { SignalRService } from '../../services/communications/signalr.service';
import { Subscription } from 'rxjs';
import { AssistanceUpdateResponse } from '../../interfaces/Responses/AssistanceStateUpdateResponse';
import * as constants from 'src/app/constants/constants';
import { MatButtonModule } from '@angular/material/button';
import { ModalComponent } from '../modal/modal.component';
import { MatDialog } from '@angular/material/dialog';
import { AssistanceCreateResponse } from 'src/app/models/assistanceCreateResponse';
import { environment } from '../../../environment/environment';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';


@Component({
  selector: 'app-header',
  imports: [CommonModule, MatSelectModule, MatFormFieldModule, TranslateModule, MatButtonModule, MatMenuModule, MatIconModule, MatTooltipModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  @Input() assistanceState!: number;
  @Input() assistancePriority!: number
  @Output() membersSwitch = new EventEmitter<boolean>();
  @Output() assistancesSwitch = new EventEmitter<boolean>();
  @Output() commentsSwitch = new EventEmitter<boolean>();

  @ViewChild('headerElementAsset') headerAsset!: ElementRef<HTMLElement>;
  @ViewChild('headerElementAssistance') headerAssistance!: ElementRef<HTMLElement>;

  langs: string[] = [];
  assisatancesStatesEnum: { [key: string]: number } = {};
  assisatancesStatesOptions: { key: string; value: number }[] = [];
  assistancePriorityEnum: { [key: string]: number } = {};

  currentLang;
  isExpert: boolean;
  assistancesToolTip: string = "";
  assistanceStateSubscription!: Subscription;
  assistanceInfo: boolean = false;

  logo: string | null = null;
  logoChanged: boolean = false;
  faviconChanged: boolean = false;
  assistanceClosed: boolean = false;
  headerTruncatedAsset: boolean = false;
  headerTruncatedAssistance: boolean = false;

  constructor(private translate: TranslateService, private configurationService: ConfigService, private apiService: ApiService, public userDataService: UserDataService, private signalService: SignalRService, public dialog: MatDialog) {
    this.langs = this.translate.getLangs();
    this.currentLang = this.translate.currentLang;
    this.isExpert = userDataService.Role == constants.UserRole.Expert;
    this.changeCompanyImages();
    this.signalREventsHook();
  }

  ngOnInit(): void {
    console.log("onInit", this.assistanceState, this.assistancePriority);
    if (!this.isExpert) {
      this.translate.get('ASSISTANCES.CANT_START_ASSISTANCE').subscribe((text: string) => { this.assistancesToolTip = text; });
    } 

    this.apiService.getAssistancesStates().subscribe(result => {
      result.forEach(item => { this.assisatancesStatesEnum[item.name] = item.id; });
      this.assisatancesStatesOptions = result.map(item => ({ key: item.name, value: item.id })).sort((a, b) => a.value - b.value);

      if (this.assistanceState == this.assisatancesStatesEnum['Closed'] || this.assistanceState == this.assisatancesStatesEnum['Cancelled']) this.assistanceClosed = true;

    });

    this.apiService.getAssistancesPriorities().subscribe(result => {
      this.assistancePriorityEnum = result;
      console.log(this.assistancePriorityEnum);
    });

    console.log('assistance', this.userDataService.assetInfo.assistances);

    this.requestNotificationPermission();
  }


  ngAfterViewInit() {
    console.log("check truncated");
    setTimeout(() => {
      this.headerTruncatedAsset = this.checkTruncation(this.headerAsset);
      this.headerTruncatedAssistance = this.checkTruncation(this.headerAssistance);
    });
  }

  checkTruncation(el?: ElementRef<HTMLElement>): boolean {
    if (!el || el.nativeElement.offsetParent === null) return false;
    return el.nativeElement.scrollWidth > el.nativeElement.clientWidth;
  }


  requestNotificationPermission(): void {
    // El navegador no soporta notificaciones o requestPermission no está disponible.
    if (typeof Notification === 'undefined' || typeof Notification.requestPermission !== 'function') return;

    if (Notification.permission === "granted") {
      console.log("Permiso de notificación concedido.");
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then(permission => {
        if (permission === "granted") {
          console.log("Permiso de notificación concedido.");
        } else {
          console.log("Permiso de notificación denegado.");
        }
      });
    }
  }

  onSelectChange(lang: string) {
    console.log("lang", lang);
    this.translate.use(lang);
    this.configurationService.changeLanguage(lang);
  }

  switchMembers(): void {
    this.assistanceInfo = false;
    this.membersSwitch.emit();
  }

  switchAssistance(): void {
    if (this.userDataService.assetInfo.parentId == 0) {
      if (this.isExpert) this.assistancesSwitch.emit();
    } else {
      this.assistanceInfo = !this.assistanceInfo;
    }
  }

  switchComments(): void {
    this.assistanceInfo = false;
    this.commentsSwitch.emit();
  }

  resetAssistanceMenu() {
    if (this.assistanceInfo) this.assistanceInfo = false;
  }

  changeAssistanceStatus(select: MatSelect) {
    select.close();
    var state = select.value;

    if (state == this.assisatancesStatesEnum['Closed'] || state == this.assisatancesStatesEnum['Cancelled']) {
      const closeAssistanceDialog = this.dialog.open(ModalComponent, {
        autoFocus: true,
        data: {
          title: 'ASSISTANCES.CLOSE_MODAL_TITLE',
          message: 'ASSISTANCES.CLOSE_MODAL_MESSAGE',
          addButtons: true
        }
      });

      closeAssistanceDialog.afterClosed().subscribe((result: boolean) => {
        if (result == true) {
          this.assistanceClosed = true;
          this.assistanceInfo = false;
          this.sendStateUpdate(state);
        }
        else this.assistanceState = this.userDataService.assetInfo.assistances[0].state;
      });

    } else {
      this.sendStateUpdate(state);
    }
  }

  reopenAssistance() {
    this.apiService.reopenAssitance(this.userDataService.assetInfo.id, this.userDataService.Id!).subscribe({
      next: (data: AssistanceCreateResponse) => {
        this.assistanceInfo = false;
        if (data == null) {
          console.log("No assistance data ", data);
          return;
        }
        console.log("Reopen assistance response:", data);
      },
      error: (error) => { console.error(error); }
    });
  }

  sendStateUpdate(state: number) {
    this.apiService.changeAssitanceState(this.userDataService.assetInfo.id, this.userDataService.Id!, this.userDataService.assetInfo.assistances[0].id, state).subscribe({
      next: (data: any) => {
        if (data == null || data.length == 0) {
          console.log("No chat data ", data);
          return;
        }
      },
      error: (error) => { console.error(error); }
    });
  }

  changeAssistancePriority(select: MatSelect) {
    select.close();
    var priority = select.value;

    this.apiService.changeAssitancePriority(this.userDataService.assetInfo.id, this.userDataService.Id!, this.userDataService.assetInfo.assistances[0].id, priority).subscribe({
      next: (data: any) => {
        if (data == null || data.length == 0) {
          console.log("No chat data ", data);
          return;
        }
      },
      error: (error) => { console.error(error); }
    });
  }

  openLibrary() {
    window.open(environment.remoteeyeUrl + "/Library/Media/?assetId=" + this.userDataService.assetInfo.id, "_blank");
  }

  signalREventsHook() {
    //TODO: revisar
    this.assistanceStateSubscription = this.signalService.onAssistanceUpdate.subscribe((result: AssistanceUpdateResponse) => {
      var lastState = this.assisatancesStatesOptions.find(e => e.value == this.userDataService.assetInfo.assistances[0].state)?.key;
      var newState = this.assisatancesStatesOptions.find(e => e.value == result.assistanceState)?.key;

      this.assistanceState = result.assistanceState;
      this.assistancePriority = result.assistancePriority;

      this.userDataService.assetInfo.assistances[0].id = result.assistanceId;
      this.userDataService.assetInfo.assistances[0].name = result.assistanceName;
      this.userDataService.assetInfo.assistances[0].description = result.assistanceDescription;
      this.userDataService.assetInfo.assistances[0].state = result.assistanceState;
      this.userDataService.assetInfo.assistances[0].priority = result.assistancePriority;

      this.assistanceClosed = (this.userDataService.assetInfo.assistances[0].state == this.assisatancesStatesEnum['Closed'] || this.userDataService.assetInfo.assistances[0].state == this.assisatancesStatesEnum['Cancelled']);

      if (this.userDataService.assetInfo.assistances[0].state == this.assisatancesStatesEnum['Open']) {

        var bodyMessage: string = "";
        this.translate.get("NOTIFICATIONS.NEW_ASSISTANCE_TITLE").subscribe((text: string) => { bodyMessage = text; });

        this.showBrowserNotification("NOTIFICATIONS.NEW_ASSISTANCE_TITLE", `${bodyMessage}: ${this.userDataService.assetInfo.name}`);
      } else {

        var bodyMessage1: string, bodyMessage2: string, bodyMessage3: string, lastStateText: string, nextStateText: string;
        bodyMessage1 = bodyMessage2 = bodyMessage3 = lastStateText = nextStateText = "";

        this.translate.get("GENERAL.ASSET").subscribe((text: string) => { bodyMessage1 = text; });
        this.translate.get("NOTIFICATIONS.LAST_STATE").subscribe((text: string) => { bodyMessage2 = text; });
        this.translate.get("NOTIFICATIONS.ACTUAL_STATE").subscribe((text: string) => { bodyMessage3 = text; });
        this.translate.get("ASSISTANCES_STATES." + lastState).subscribe((text: string) => { lastStateText = text; });
        this.translate.get("ASSISTANCES_STATES." + newState).subscribe((text: string) => { nextStateText = text; });

        this.showBrowserNotification("NOTIFICATIONS.ASSISTANCE_CHANGE_STATE", `${bodyMessage1}: ${this.userDataService.assetInfo.name}\n${bodyMessage2}: ${lastStateText}\n${bodyMessage3}: ${nextStateText}`);
      }
    });
  }

  private showBrowserNotification(title: string, message: string): void {
    if (document.visibilityState === "hidden" && Notification.permission === "granted") {
      let titleTranslated: string = "";
      this.translate.get(title).subscribe((text: string) => { titleTranslated = text; });

      new Notification(titleTranslated, { body: message });
    }
  }

  objectKeys(obj: { [key: string]: any }): string[] {
    return Object.keys(obj);
  }

  ngOnDestroy() {
    this.assistanceStateSubscription.unsubscribe();
  }

  changeCompanyImages() {
    let favIcon: HTMLLinkElement | null = document.querySelector<HTMLLinkElement>('link[rel*="icon"]');
    if (favIcon != null) {
      favIcon.href = "favicon.ico";
      if (this.userDataService.favicon != null && this.userDataService.favicon != "") {
        if (favIcon != null) {
          favIcon.href = this.userDataService.favicon!.replace("ico", "png");
          this.faviconChanged = true;
        }
      }
    }

    if (this.userDataService.logoHeader != null && this.userDataService.logoHeader != "") {
      this.logo = this.userDataService.logoHeader;
      this.logoChanged = true;
    }
  }

}
